import config from 'district-ui-client/config/environment'
import sinon from 'sinon'
import { addDays } from 'date-fns'

const encodeBase64 = btoa
/**
 * URL encodes the base64 representation of a string
 * and removes any padding base64 padding
 *
 * See Appendix C. for more details on base64 url encoding without padding
 * https://www.rfc-editor.org/rfc/rfc7515.txt
 *
 * @param  {String} value string to be encoded
 * @return {String}       encoded string
 */
function base64UrlEncode(value: string) {
  const encoded = encodeBase64(value)
  const [encodedWithoutPadding] = encoded.split('=')
  return encodeURI(encodedWithoutPadding)
}

/**
 * Creates an unsigned JWT
 *
 * There's no need to sign the JWT during development,
 * so encoding it is enough
 *
 * @param  {Object} object payload object to encode
 * @return {String}        unsigned JWT
 */
export function encodeJWT(object: Record<string, unknown>) {
  const header = JSON.stringify({
    alg: 'FAKE',
    typ: 'JWT',
  })

  const payload = JSON.stringify(object)

  // encoded JWT structure: header.payload.signature
  const encodedHeader = base64UrlEncode(header)
  const encodedPayload = base64UrlEncode(payload)
  const data = `${encodedHeader}.${encodedPayload}`

  const signature = base64UrlEncode(data)

  const token = `${data}.${signature}`

  return token
}

const decodedToken = {
  // expiry = time since epoch + 7 days (in milliseconds)
  exp: addDays(new Date(), 7).getTime() / 1000, // Divide by 1000 because backend sends value in seconds
  data: {
    id: 1,
    roles: [],
    district_id: 1,
    type: 'disco',
  },
}

/**
 * Stub a token that the auth-token service will use in acceptance tests.
 */
export function authenticateSession(hooks: NestedHooks, token: Record<string, unknown> = decodedToken) {
  hooks.beforeEach(function () {
    const authToken = this.owner.lookup('service:auth-token') // see frontend auth package
    sinon
      .stub(authToken.fetcher, 'request')
      .withArgs(config.jwtURL)
      // @ts-expect-error - kyresponse is weird, we only call text(), just stub that.
      .returns({ text: () => Promise.resolve(encodeJWT(token)) })
  })
}
